import { Component, ViewChild } from '@angular/core';
import { ControlContainer, FormsModule, NgForm, NgModelGroup } from '@angular/forms';

import { IStopDetailsGroup } from 'app/models/filter-form.models';
import { FilterService } from 'app/services/filter.service';
import { makeControlDirty } from 'app/utils/form.utils';
import { CONTRABAND_EVIDENCE, REASON_FOR_SEARCH, REASON_FOR_STOP, RESULT_OF_STOP } from './constants';
import { FilterItemComponent } from '../filter-item/filter-item.component';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { NgFor } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';

@Component({
  selector: 'app-stop-details-tab',
  templateUrl: './stop-details-tab.component.html',
  styleUrls: ['./stop-details-tab.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  imports: [FormsModule, FilterItemComponent, MatFormField, MatSelect, NgFor, MatOption],
})
export class StopDetailsTabComponent {
  @ViewChild('stopDetails') ngModelGroup!: NgModelGroup;

  stopDetailsGroup: IStopDetailsGroup = {
    reasonForStop: undefined,
    reasonForSearch: undefined,
    contrabandOrEvidence: undefined,
    resultOfStop: undefined,
  };

  reasonForStopOptions = REASON_FOR_STOP;
  reasonForSearchOptions = REASON_FOR_SEARCH;
  contrabandOrEvidenceOptions = CONTRABAND_EVIDENCE;
  resultOfStopOptions = RESULT_OF_STOP;

  constructor(private filterService: FilterService) {
    const { appliedFilters: filters } = this.filterService;

    if (!filters.stopDetailsFilter) return;

    this.stopDetailsGroup = {
      reasonForStop: filters.stopDetailsFilter.reasonsForStop,
      reasonForSearch: filters.stopDetailsFilter.reasonsForSearch,
      contrabandOrEvidence: filters.stopDetailsFilter.contrabandOrEvidence,
      resultOfStop: filters.stopDetailsFilter.resultsOfStop,
    };
  }

  get reasonForStopValue() {
    return this.stopDetailsGroup.reasonForStop?.toString() ?? undefined;
  }

  get reasonForSearchValue() {
    return this.stopDetailsGroup.reasonForSearch?.toString() ?? undefined;
  }

  get contrabandOrEvidenceValue() {
    return this.stopDetailsGroup.contrabandOrEvidence?.toString() ?? undefined;
  }

  get resultOfStopValue() {
    return this.stopDetailsGroup.resultOfStop?.toString() ?? undefined;
  }

  clearFilter(filter: 'reasonForStop' | 'reasonForSearch' | 'contrabandOrEvidence' | 'resultOfStop'): () => void {
    return () => {
      makeControlDirty(this.ngModelGroup.control);

      switch (filter) {
        case 'reasonForStop':
          this.stopDetailsGroup.reasonForStop = undefined;
          break;
        case 'reasonForSearch':
          this.stopDetailsGroup.reasonForSearch = undefined;
          break;
        case 'contrabandOrEvidence':
          this.stopDetailsGroup.contrabandOrEvidence = undefined;
          break;
        case 'resultOfStop':
          this.stopDetailsGroup.resultOfStop = undefined;
          break;
      }
    };
  }
}
